"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetaAdLibraryPageId = isMetaAdLibraryPageId;
exports.extractMetaAdLibraryPageId = extractMetaAdLibraryPageId;
/**
 * Meta page IDs (as used for `AdLibrary.libraryId`) are numeric strings, typically 12-16 digits.
 * The 8-digit minimum keeps short numeric brand names out of the page-ID fast-paths.
 */
const META_PAGE_ID_PATTERN = /^\d{8,}$/;
/** Whether a string has the Meta page-ID shape (8+ digit numeric string). */
function isMetaAdLibraryPageId(value) {
    return META_PAGE_ID_PATTERN.test(value);
}
/**
 * Extracts the Meta page ID from a Meta Ad Library URL (`facebook.com/ads/library/?...view_all_page_id=<id>`),
 * with or without protocol. Returns null for anything else — free text, other URLs, or a missing/invalid id.
 */
function extractMetaAdLibraryPageId(text) {
    const trimmed = text.trim();
    if (!trimmed || trimmed.includes(' '))
        return null;
    let url;
    try {
        url = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`);
    }
    catch {
        return null;
    }
    const host = url.hostname.toLowerCase();
    if (host !== 'facebook.com' && host !== 'www.facebook.com')
        return null;
    if (!url.pathname.includes('ads/library'))
        return null;
    const pageId = url.searchParams.get('view_all_page_id');
    if (!pageId || !META_PAGE_ID_PATTERN.test(pageId))
        return null;
    return pageId;
}
